module.exports = __webpack_public_path__ + "img/logos_desktop_1.43e48d26.png";